export const ru = {
    all: 'Все',
    'region-except': '{region} (кроме {except})'
};
